import { render } from "./UserAutocomplete.vue?vue&type=template&id=0f694a3e&ts=true"
import script from "./UserAutocomplete.vue?vue&type=script&lang=ts"
export * from "./UserAutocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__